import { Video } from "@/common/types/video";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { TabList } from "@/components/molecules/TabList";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { TabContent } from "@/components/organisms/TabContent";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { exerciseStart } from "@/common/functions/flutter";
import { useRecoilValue } from "recoil";
import { studentUserState } from "@/common/states/user";
import { exerciseSetCategory } from "@/data/category";
import { useNavigate, useParams } from "react-router";
import { ExercisePointEligibility } from "@/common/types/student";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import {
  GET_EXERCISE_AVAILABILITY,
  GET_VIDEOS_BY_CATEGORY,
} from "@/common/querykeys";
import { ExerciseWeeklyList } from "@/components/molecules/ExerciseWeeklyList";

const fetchVideosByCategory = async (category: string): Promise<Video[]> => {
  return await request<Video[]>({
    method: "GET",
    url: `/video-content/category/${category}`,
  });
};

export const ExerciseSetPage = () => {
  const student = useRecoilValue(studentUserState);
  const navigate = useNavigate();
  const { exerciseSetQuater: categoryParam } = useParams<{
    exerciseSetQuater: string;
  }>();
  const [selectedVideoId, setSelectedVideoId] = useState<string | null>(null);
  const [exerciseModalShow, setExerciseModalShow] = useState(false);
  const category = categoryParam || exerciseSetCategory[0]?.id;

  const { data: videos, isPending } = useQuery({
    queryKey: [GET_VIDEOS_BY_CATEGORY, category],
    queryFn: () => fetchVideosByCategory(category),
    initialData: [],
    select: (data) => {
      if (category === "EVENT") {
        return data?.length ? [data[1]] : [];
      }
      return data;
    },
  });

  // 학생이 운동할 때 포인트 지급 가능 여부 조회 (🧑‍🎓)
  const { data: exercisePointEligibility } = useQuery<ExercisePointEligibility>(
    {
      queryKey: [GET_EXERCISE_AVAILABILITY],
      queryFn: async () => {
        const res = await request<ExercisePointEligibility[]>({
          method: "GET",
          url: `/student/video-point-eligibility/${student.id}`,
        });

        return res[0];
      },
    }
  );

  const handleTabChange = (tabId: string) => {
    navigate(`/exercise/set/${tabId}`);
  };

  const handleExerciseStart = (videoId: string) => {
    exerciseStart(student?.id, videoId);
  };

  const handleExerciseConfirm = (result?: boolean, videoId?: string) => {
    if (result) {
      exerciseStart(student?.id, videoId);
    } else {
    }
  };

  return (
    <>
      <MainTemplate
        nav={false}
        subPage={false}
        menuBtn={false}
        pageTitle="신체 건강 운동 프로그램"
        buttonLeft={
          <Buttons
            type="button"
            size="headerTextIcon"
            layout="text"
            color="bright100"
            icon={<IconArrow />}
            label="운동"
            onClick={() => navigate("/exercise")}
          />
        }
      >
        <TabContent
          nav={false}
          tabList={
            <TabList
              data={exerciseSetCategory}
              activeTab={category}
              onTabChange={handleTabChange}
            />
          }
        >
          <ExerciseWeeklyList
            videos={videos}
            isLoading={isPending}
            onClick={(videoId: string) => {
              // if (
              //   exercisePointEligibility?.exerciseCount === "36" ||
              //   exercisePointEligibility?.points === 50000
              // ) {
              //   setExerciseModalShow(true);
              //   setSelectedVideoId(videoId);
              // } else {
              //   handleExerciseStart(videoId);
              // }
              handleExerciseStart(videoId);
            }}
          />
        </TabContent>
      </MainTemplate>
      {/* {exerciseModalShow &&
        (exercisePointEligibility &&
        exercisePointEligibility?.points === 50000 &&
        exercisePointEligibility?.exerciseCount === "36" ? (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={(result: boolean) => {
              if (result && selectedVideoId) {
                handleExerciseStart(selectedVideoId);
              }
              setSelectedVideoId(null);
            }}
            type="all"
          />
        ) : exercisePointEligibility?.points === 50000 ? (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={(result: boolean) => {
              if (result && selectedVideoId) {
                handleExerciseStart(selectedVideoId);
              }
              setSelectedVideoId(null);
            }}
            type="point"
          />
        ) : (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={(result: boolean) => {
              if (result && selectedVideoId) {
                handleExerciseStart(selectedVideoId);
              }
              setSelectedVideoId(null);
            }}
            type="exercise"
          />
        ))} */}
    </>
  );
};
